export default __webpack_public_path__ + "static/media/Pin_Job_JumpStart.53eb2111.svg";